<template>
  <v-dialog v-model="dialog" width="500">
    <v-btn depressed slot="activator" color="primary" class="white--text" small>
      {{ buttonTitle() }}
    </v-btn>

    <v-card tile flat>
      <v-toolbar tile flat card dense color="theme_primary" class="white--text">
        <v-spacer></v-spacer>
        <v-toolbar-title class="white-text text-capitalize"
          >Bank information</v-toolbar-title
        >

        <v-spacer></v-spacer>
        <v-toolbar-side-icon>
          <v-icon color="white">monetization_on</v-icon>
        </v-toolbar-side-icon>
      </v-toolbar>

      <v-card-text>
        <v-text-field
          v-model="bankInformation.name"
          required
          label="Name"
          background-color="white"
        />
        <v-text-field
          v-model="bankInformation.iban"
          required
          label="Iban"
          background-color="white"
        />
        <v-text-field
          v-model="bankInformation.beneficiary_bank"
          required
          label="Beneficiary Bank"
          background-color="white"
        />
        <v-text-field
          v-model="bankInformation.account_number"
          required
          label="Account Number"
          background-color="white"
        />
        <v-text-field
          v-model="bankInformation.bank_code"
          required
          label="Bank Code"
          background-color="white"
        />
        <v-text-field
          v-model="bankInformation.branch_code"
          required
          label="Branch Code"
          background-color="white"
        />
        <v-text-field
          v-model="bankInformation.swift_code"
          required
          label="Swift Code"
          background-color="white"
        />
        <v-text-field
          v-model="bankInformation.account_name"
          required
          label="Account Name"
          background-color="white"
        />

        <v-autocomplete
          :items="currencies"
          item-value="id"
          item-text="name"
          v-model="bankInformation.currency_id"
          background-color="white"
          autocomplete="newcompany-subsidiary-currency"
          label="Currency"
        >
          <template slot="selection" slot-scope="data">
            {{ data.item.name }}
          </template>
          <template slot="item" slot-scope="data">{{
            data.item.name
          }}</template>
        </v-autocomplete>
        <v-checkbox
          v-model="bankInformation.show_in_accounting_dashboard"
          label="Show Bank Account in Accounting Dashboard"
        />
        <v-text-field
          v-model="bankInformation.initial_amount"
          required
          label="Initial Amount"
          background-color="white"
        />
      </v-card-text>

      <v-divider></v-divider>

      <v-layout justify-center align-center row>
        <v-btn @click="save" small flat color="success">Save</v-btn>
        <v-btn @click="dialog = false" small flat color="error">Cancel</v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import CREATE_BANK_INFORMATION from "../../graphql/bank_informations/create.gql";
import UPDATE_BANK_INFORMATION from "../../graphql/bank_informations/update.gql";
import { mapGetters } from "vuex";

export default {
  props: {
    objectId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
      bankInformation: {},
    };
  },
  methods: {
    buttonTitle() {
      return this.objectId ? "Update" : "New";
    },
    save() {
      this.dialog = false;
      this.bankInformation.subsidiary_id = this.newCompany.subsidiary.id;
      this.bankInformation.company_id = this.$route.params.id;
      this.bankInformation.initial_amount =
        parseFloat(this.bankInformation.initial_amount) || 0;
      const name = "bank_information " + this.bankInformation.name;
      if (this.objectId) {
        this.sendMutation(
          "updated",
          name,
          UPDATE_BANK_INFORMATION,
          this.bankInformation
        );
      } else {
        this.sendMutation(
          "created",
          name,
          CREATE_BANK_INFORMATION,
          this.bankInformation
        ).then(() => {
          this.bankInformation = {};
        });
      }
    },
  },
  computed: {
    ...mapGetters("commonStore", ["currencies"]),
    ...mapGetters("companyStore", ["newCompany", "getBankInformation"]),
  },
  mounted() {
    if (this.objectId) {
      this.bankInformation = this.getBankInformation(this.objectId);
    }
  },
};
</script>
